import * as React from "react";
import { Component } from "react";
import Moment from "react-moment";
import { AuthManager } from "../../component/auth/AuthContext";
import FileChooser from "../../component/filechooser/FileChooser";
import TaskApi, { Task } from "../../api/TaskApi";
import MessageService from "../../service/MessageService";
import { Button } from "reactstrap";
import TaskModal from "../../component/task/TaskModal";
import i18n from "i18next";

interface TaskListProps {
  authManager: AuthManager;
}

interface TaskListState {
  tasks: Task[];
  taskTypes?: string[];
  modalOpened: boolean;
}

export default class TaskList extends Component<TaskListProps, TaskListState> {
  private taskApi: TaskApi;

  constructor(props: TaskListProps) {
    super(props);

    this.taskApi = TaskApi.with(props.authManager.cancelableClient());

    this.state = {
      tasks: [],
      modalOpened: false,
    };
  }

  componentDidMount() {
    this.taskApi.getTaskTypes().then((taskTypes) => {
      this.setState({ taskTypes });
    });
    this.search();
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="container-fluid m-2">
          <div className="row form-group">
            <div className="col-md-3">
              {i18n.t("task.importTask")}:
              <FileChooser className="btn btn-secondary" onFile={(file) => this.onImportPartFile(file)} accept=".json">
                {i18n.t("task.chooseFile")}
              </FileChooser>
            </div>
            <div className="col-md-3">
              {i18n.t("task.importParamTask")} :
              <FileChooser
                className="btn btn-secondary"
                onFile={(file) => this.onImportPartParamFile(file)}
                accept=".json"
              >
                {i18n.t("task.chooseFile")}
              </FileChooser>
            </div>

            <div className="col-md-3">
              {i18n.t("task.importAIRegionTask")} :
              <FileChooser
                className="btn btn-secondary"
                onFile={(file) => this.onImportAiRegionFile(file)}
                accept=".json"
              >
                {i18n.t("task.chooseFile")}
              </FileChooser>
            </div>

            <div className="col-md-3">
              <Button onClick={() => this.openModal()}>{i18n.t("task.launchTask")}</Button>

              {this.state.modalOpened && (
                <TaskModal
                  taskTypes={this.state.taskTypes}
                  onCancel={() => this.closeModal()}
                  onLaunch={(opts) => this.launchTask(opts)}
                />
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <button className="btn btn-secondary" onClick={(evt) => this.search()}>
                {i18n.t("task.refresh")}
              </button>

              <table className="table table-striped table-dark">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>{i18n.t("task.state")}</th>

                    <th>{i18n.t("task.type")}</th>
                    <th>{i18n.t("task.desc")}</th>

                    <th>{i18n.t("global.total")}</th>
                    <th>{i18n.t("task.success")}</th>
                    <th>{i18n.t("task.failure")}</th>
                    <th>{i18n.t("task.debitPerMin")}</th>
                    <th>ETA</th>

                    <th>{i18n.t("task.updated")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.tasks.map((task, idx) => (
                    <tr key={task.id}>
                      <td>{task.id}</td>
                      <td>{task.state}</td>

                      <td>{task.type}</td>
                      <td>{task.desc}</td>

                      <td>{task.total}</td>
                      <td>{task.success}</td>
                      <td>{task.failure}</td>
                      <td>{task.exportedItemPerMin}</td>
                      <td> {task.estimatedEnd && <Moment format="DD/MM/YYYY HH:mm">{task.estimatedEnd}</Moment>}</td>
                      <td>
                        <Moment format="DD/MM/YYYY HH:mm">{task.updated}</Moment>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private onImportPartFile(file: File) {
    this.taskApi.postImportPartFile(file).then(() => this.onTaskSuccessfullyLaunched());
  }

  private onImportPartParamFile(file: File) {
    this.taskApi.postImportPartParamFile(file).then(() => this.onTaskSuccessfullyLaunched());
  }

  private onImportAiRegionFile(file: File) {
    this.taskApi.postImportAiRegionFile(file).then(() => this.onTaskSuccessfullyLaunched());
  }

  private onTaskSuccessfullyLaunched() {
    MessageService.info(i18n.t("task.launched"));
    this.search();
  }

  private search() {
    this.taskApi.getTasks().then((tasks) => this.setState({ tasks }));
  }

  private launchTask(options: { type: string; params: Object }) {
    this.taskApi.launchTask(options.type, options.params).then((task) => {
      MessageService.info("Task " + task.id + " launched");
      this.closeModal();
    });
  }

  private openModal() {
    this.setState({ modalOpened: true });
  }

  private closeModal() {
    this.setState({ modalOpened: false });
  }
}
